// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { PolylineTree } from './polyline-tree';


export class WPData {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):WPData {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsWPData(bb:flatbuffers.ByteBuffer, obj?:WPData):WPData {
  return (obj || new WPData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsWPData(bb:flatbuffers.ByteBuffer, obj?:WPData):WPData {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new WPData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static bufferHasIdentifier(bb:flatbuffers.ByteBuffer):boolean {
  return bb.__has_identifier('WBPD');
}

polylineTrees(index: number, obj?:PolylineTree):PolylineTree|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new PolylineTree()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

polylineTreesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startWPData(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addPolylineTrees(builder:flatbuffers.Builder, polylineTreesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, polylineTreesOffset, 0);
}

static createPolylineTreesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startPolylineTreesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endWPData(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static finishWPDataBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, 'WBPD');
}

static finishSizePrefixedWPDataBuffer(builder:flatbuffers.Builder, offset:flatbuffers.Offset) {
  builder.finish(offset, 'WBPD', true);
}

static createWPData(builder:flatbuffers.Builder, polylineTreesOffset:flatbuffers.Offset):flatbuffers.Offset {
  WPData.startWPData(builder);
  WPData.addPolylineTrees(builder, polylineTreesOffset);
  return WPData.endWPData(builder);
}
}
